const footerStyle = {
  paddingTop: "1rem",
  fontSize: "1rem",
  color: "rgb(158, 187, 187)",
  backgroundColor: "#1a2538",
  left: 0,
  bottom: 0,
  width: "100%",
};

const textStyle = {
  color: "rgb(158, 187, 187)",
  textDecoration: "none",
};

function Footer() {
  return (
    <div>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          width: "100%",
          color: "azure",
          backgroundColor: "#333",
          height: "3rem",
        }}
      >
        <a
          href="#goto-top"
          alt="Back to top"
          style={{ textDecoration: "none", color: "azure" }}
        >
          Back to top
        </a>
      </div>
      <div style={footerStyle}>
        <div className="container">
          <div
            className="d-flex justify-content-between flex-wrap"
            style={{ marginTop: "2rem", padding: "1rem" }}
          >
            <div style={{ marginBottom: "2rem" }}>
              <p>
                <big>
                  <b>
                    <u>Services available at</u>
                  </b>
                </big>
              </p>
              <ol style={{ listStyle: "none", padding: 0 }}>
                <li>
                  <a
                    style={textStyle}
                    href="https://www.google.com/maps/search/wardha/@20.7044907,78.6455469,15z"
                  >
                    Wardha
                  </a>
                </li>
                <li>
                  <a
                    style={textStyle}
                    href="https://www.google.com/maps/place/Selu,+Maharashtra+431503/@19.4563085,76.4264076,15z/data=!3m1!4b1!4m5!3m4!1s0x3bda9f92adbc5b17:0x7a7ec766ca6faaf4!8m2!3d19.4532003!4d76.4389549"
                  >
                    Selu
                  </a>
                </li>
                <li>
                  <a
                    style={textStyle}
                    href="https://www.google.com/maps/place/Bhugaon,+Bavdhan,+Pune,+Maharashtra/@18.500651,73.7431424,15z/data=!3m1!4b1!4m5!3m4!1s0x3bc2be746f7432f9:0xcd7342b7bb1bba36!8m2!3d18.5011162!4d73.7507669"
                  >
                    Bhugaon
                  </a>
                </li>
              </ol>
            </div>
            <div>
              <p>
                <big>
                  <b>
                    <u>Contact</u>
                  </b>
                </big>
              </p>
              <ol style={{ listStyle: "none", padding: 0, cursor: "pointer" }}>
                <li>
                  <span>
                    <b>Phone</b>
                  </span>
                  : +91-1231231230
                </li>
                <li>
                  <span>
                    <b>Instagram ID</b>
                  </span>
                  : groxeries-shopping
                </li>
                <li>
                  <span>
                    <b>Email</b>
                  </span>
                  : groxeries@gmail.com
                </li>
              </ol>
            </div>
          </div>
          <hr />
          <p
            style={{
              color: "goldenrod",
              fontSize: "1.5rem",
              textAlign: "center",
              paddingBottom: "2rem",
            }}
          >
            <b>GroXeries</b>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
